<template>
  <router-view v-slot="{ Component }" class="bg-slate-950">
    <component :is="Component" />
  </router-view>
</template>
